import state from './moduleChatContactState'
import actions from './moduleChatContactActions'
import getters from './moduleChatContactGetters'
import mutations from './moduleChatContactMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
